import { SimpleChanges , Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-learning-support-modal',
  templateUrl: './learning-support-modal.component.html',
  styleUrls: ['./learning-support-modal.component.css']
})
export class LearningSupportModalComponent implements OnInit {

  @Input() getOneItem: any;
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['getOneItem']) {
      console.log('Data updated:', this.getOneItem);
      // Optionally trigger change detection
    }
  }

  ngOnInit() {
  }
  closeButton() {
    this.getOneItem = {
      rephrase:[]
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-modal-module/learning-support-modal/learning-support-modal.component.ts